import { TIIndicatorPointToHighChartIndicatorPointMapper } from '../../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper';
import { TIIndicatorDataModel } from '../../models/data-point/ti-indicator-data.model';
import { IndicatorOptionModel } from '../../models/drop-down-list/indicator-option.model';
import { IComponent } from "../component.interface";
import { TiChartSeriesComponent } from '../ti-chart-series.component';

export class MACDIndicatorComponent implements IComponent {
    public id = '';

    private tiChartSeries: TiChartSeriesComponent;

    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.tiChartSeries = tiChartSeries;
    }

    public updateChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, tiIndicatorDataIndex: number, isUpdate: boolean) {
        const macdHistSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('MACD_HIST') >= 0);
        const macdHist = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_HIST') >= 0);
        const tiIndicatorMacdHistIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators.findIndex((x: TIIndicatorDataModel) => x.name.indexOf('MACD_HIST') >= 0);
        if (!macdHist || !macdHistSeries || tiIndicatorMacdHistIndex <= - 1) {
            return;
        }

        const machHistIndicatorDataPoint = macdHist.points[macdHist.points.length - 1];
        if (!machHistIndicatorDataPoint) {
            return;
        }

        if (isUpdate) {
            const lastChartBar = macdHistSeries.points.find((x: any) => x.x == machHistIndicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdHistIndex].points.findIndex(x => x.xValue == machHistIndicatorDataPoint.xValue);
            // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdHistIndex].points[tiIndicatorDataPointIndex] = machHistIndicatorDataPoint;
            }

            if (!lastChartBar) {
                const dataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdHistIndex], indicatorOption.value, false);
                macdHistSeries.setData(dataPoints.points, true, false, true);
            } else {
                const lastHighChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, machHistIndicatorDataPoint, macdHist);
                lastChartBar.update(lastHighChartDataPoint, false);
            }
        } else {
            const highChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, machHistIndicatorDataPoint, macdHist);
            macdHistSeries.addPoint(highChartDataPoint, false);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdHistIndex].points.push(machHistIndicatorDataPoint);
        }

        const macdLineSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
        const macdLines = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
        const tiIndicatorMacdLinesIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators.findIndex((x: TIIndicatorDataModel) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
        if (!macdLines || !macdLineSeries || tiIndicatorMacdLinesIndex <= - 1) {
            return;
        }

        const macdLineIndicatorDataPoint = macdLines.points[macdLines.points.length - 1];
        if (!macdLineIndicatorDataPoint) {
            return;
        }

        const needZone = macdLines.needHighChartZone(macdLineSeries.type);
        if (isUpdate) {
            const lastChartBar = macdLineSeries.points.find((x: any) => x.x == macdLineIndicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].points.findIndex(x => x.xValue == macdLineIndicatorDataPoint.xValue);
            // // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].points[tiIndicatorDataPointIndex] = macdLineIndicatorDataPoint;
            }

            if (!lastChartBar) {
                const point = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex];
                const dataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(point, indicatorOption.value, true);
                macdLineSeries.setData(dataPoints.points, true, false, true);
                if (needZone) {
                    this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].zones = dataPoints.zones;
                }
            } else {
                const lastHighChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, macdLineIndicatorDataPoint, macdLines);
                lastChartBar.update(lastHighChartDataPoint, false);

                if (needZone) {
                    const existingZoneIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].zones.findIndex((x: any) => x.value == macdLineIndicatorDataPoint.xValue);
                    if (existingZoneIndex > -1) {
                        const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(macdLineIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                        this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].zones[existingZoneIndex] = lastHighChartZoneDataPoint;
                    }
                }
            }
        } else {
            const highChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, macdLineIndicatorDataPoint, macdLines);
            macdLineSeries.addPoint(highChartDataPoint, false);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].points.push(macdLineIndicatorDataPoint);
            
            if (needZone) {
                const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(macdLineIndicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].zones.push(lastHighChartZoneDataPoint);
            }
        }

        if (needZone) {
            macdLineSeries.update({
                zones: this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorMacdLinesIndex].zones,
                type: macdLineSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            });
        }
    }

    public updateHistoryChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, firstPoint: number) {
        const macdHistSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('MACD_HIST') >= 0);
        const macdHist = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_HIST') >= 0);
        if (!macdHist || !macdHistSeries) {
            return;
        }

        for (let j = macdHist.points.length - 1; j > 0; j--) {
            const indicatorDataPoint = macdHist.points[j];
            if (indicatorDataPoint.timestamp && indicatorDataPoint.xValue < firstPoint) {
                const point = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, macdHist);
                macdHistSeries.addPoint(point, false);
            }
        }

        const macdLineSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
        const macdLines = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('MACD_SIGNAL_LINE') >= 0);
        if (!macdLines || !macdLineSeries) {
            return;
        }

        const needZone = macdLines.needHighChartZone(macdHistSeries.type);
        for (let j = macdLines.points.length - 1; j > 0; j--) {
            const indicatorDataPoint = macdLines.points[j];
            if (indicatorDataPoint.timestamp && indicatorDataPoint.xValue < firstPoint) {
                const point = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, macdLines);
                macdLineSeries.addPoint(point, false);
                if (needZone) {
                    const zonePoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, indicatorData);
                    macdLines.zones.unshift(zonePoint);
                }
            }
        }

        if (needZone) {
            macdLineSeries?.update({
                zones: macdLines.zones,
                type: macdLineSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            }, false);
        }
    }
}